<!-- <div class="tw-max-w-full tw-p-6 tw-bg-[var(--sys-bg-container-body)] tw-box-border"> -->
    <div class="tw-grid tw-gap-4 tw-p-3 tw-w-full tw-max-w-full
        tw-bg-[var(--sys-bg-container-body)] tw-h-full tw-max-h-full tw-overflow-hidden tw-box-border"
        [class.tw-grid-cols-1]="isMobile" 
        [class.md:tw-grid-cols-12]="!isMobile"
    >
        <aside [class.tw-hidden]="isMobile && showDetail"
            [ngClass]="isMobile ? 'tw-col-span-1' : 'md:tw-col-span-4 lg:tw-col-span-3'"
            class="tw-h-full tw-min-h-0"
        >
            <ng-content select="[sidebarContent]"></ng-content>

            @if (!hasSidebarContent) {
                <app-sidebar-base [showSidebarHeader]="showSidebarHeader">
                    <ng-container sidebarTitle>
                        <ng-content select="[sidebarTitle]"></ng-content>
                    </ng-container>

                    <ng-container sidebarActions>
                        <ng-content select="[sidebarActions]"></ng-content>
                    </ng-container>

                    <ng-container sidebar>
                        <ng-content></ng-content> 
                    </ng-container>
                </app-sidebar-base>
            }
        </aside>

        <main [class.tw-hidden]="isMobile && !showDetail"
            [ngClass]="isMobile ? 'tw-col-span-1' : 'md:tw-col-span-8 lg:tw-col-span-9'"
            class="tw-h-full tw-w-full tw-flex tw-flex-col tw-min-h-0">

            <ng-content select="[mainContent]"></ng-content>

            @if (!hasMainContent) {
                <app-main-base 
                    [isMobile]="isMobile" 
                    (back)="backToSidebar.emit()"
                >
                    <ng-container mainTitle>
                        <ng-content select="[headerTitle]"></ng-content>
                    </ng-container>
                    
                    <ng-container mainActions>
                        <ng-content select="[actions]"></ng-content>
                    </ng-container>

                    <ng-container mainBody>
                        <ng-content select="[content]"></ng-content>
                    </ng-container>
                </app-main-base>
            }
        </main>
    </div>
<!-- </div> -->